// Module
var code = "<!-- ko with: _queryBuilder --> <!-- ko template: { html: $data.GetTemplateHtml.bind($data), afterRender: $data.AfterRender.bind($data) } --><!-- /ko --> <!-- /ko -->";
// Exports
export default code;